import styled from "styled-components";

export const Title = styled.div`
    margin: 0px;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.6;
    letter-spacing: 0.0075em;
    padding: 5px 7px;
    flex: 0 0 auto;
    color: white;

`
